export default "__VITE_ASSET__NXZyBxKU__"